import type { DexPriceEntry, DexPricesResponse } from '../types/trade';

export function hasDexPriceData(data: DexPricesResponse | null): boolean {
  if (!data) {
    return false;
  }

  return Object.keys(data.dex_prices).length > 0;
}

export function getDexChains(data: DexPricesResponse): string[] {
  return Object.keys(data.dex_prices);
}

export function getDexDiffPct(entry: DexPriceEntry, cexPrice: number | null): number | null {
  if (!cexPrice) {
    return null;
  }

  return ((entry.price - cexPrice) / cexPrice) * 100;
}
